// Copyright (c) 2021, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'

import { DynamicPicklist } from '../'

import { QUERY_EMPLOYERGROUP_EMPLOYERS } from '../../queries'

import { decodeBase64 } from '../../utils'


export const FilterEmployerGroupEmployers = ({ employerGroupId, title, value, onChange, disabled }) => (
  <div className="sidebar__item slds-p-top_medium slds-p-right_large slds-p-bottom_small slds-p-left_large">
    <div className="slds-grid slds-wrap">
      <div className="slds-col slds-size_1-of-1 sidebar__item__title">
        {title}
      </div>
      <div className="slds-col slds-size_3-of-4">
        <div className="sidebar__item__choice">
          <DynamicPicklist
            id='employers'
            query={QUERY_EMPLOYERGROUP_EMPLOYERS}
            field='friendlyName'
            params={{
              employerGroupId: decodeBase64(employerGroupId)
            }}
            defaultValue='All'
            value={value}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  </div>
)

FilterEmployerGroupEmployers.propTypes = {
  employerGroupId: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
}

FilterEmployerGroupEmployers.defaultProps = {
  title: 'Employer',
  value: ''
}



// WEBPACK FOOTER //
// ./src/components/filter-employergroup-employers/index.js